module.exports = __webpack_public_path__ + "img/My_Account_Mobile.jpg";